import { Typography, Box, Divider, Container, Grid, Button } from '@material-ui/core'
import Link from 'next/link'
import { useFetch } from '../context/useFetch'
import i18n from '../i18n/i18n'
import { pictureUrl } from '../common/pictureUrl'
import ReactMarkdown from 'react-markdown'

export const WhoAreWe = () =>
  useFetch(
    ({ fetch }) => ({
      conf: fetch('conf')
    }),
    ({ conf }) => (
      <Container>
        <Grid container spacing={5}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h1">{i18n.t('main.who_are_we.title')}</Typography>

            <Typography>
              {i18n.t('main.who_are_we.description')} <Link href="/p/who-are-we">{i18n.t('header.more')}</Link>
            </Typography>

            <Box style={{ clear: 'both' }} py={3}>
              <Divider />
            </Box>

            <Typography variant="h2" align="center">
              {i18n.t('main.our_mission.title')}
            </Typography>

            <Typography variant="body1">{i18n.t('main.our_mission.des1')}</Typography>

            <Typography>
              {i18n.t('main.our_mission.des2')} <Link href="/p/why-trust-me">{i18n.t('header.more')}</Link>
            </Typography>

            <Box style={{ clear: 'both' }} mt={3} />
          </Grid>

          {conf.featured_company && (
            <Grid item xs={12} sm={4}>
              <Typography variant="h1">{i18n.t('main.company.title')}</Typography>

              <Typography variant="h2" align="center">
                {conf.featured_company.name}
              </Typography>

              <Typography paragraph align="center">
                {conf.featured_company.logo && (
                  <img src={pictureUrl({ record_type: 'Company', record_id: conf.featured_company.id, name: 'logo' }, 120, 120)} style={{ height: '120px' }} />
                )}
              </Typography>

              <Typography paragraph>{conf.featured_company.description}</Typography>

              <Typography paragraph align="right">
                <Link href={`/company/${conf.featured_company.hashid}`}>
                  <Button size="small" variant="outlined" color="secondary">
                    {i18n.t('main.company.offer_of', { company: conf.featured_company.name })}
                  </Button>
                </Link>
              </Typography>
            </Grid>
          )}

          <Grid item xs={12} sm={4}>
            <Typography variant="h1">{i18n.t('main.job_of_the_day.title')}</Typography>

            <Typography variant="h2" align="center">
              {conf.featured_job_label}
            </Typography>

            <Typography paragraph align="center">
              {conf.featured_job_picture && <img src={pictureUrl(conf.featured_job_picture, 120, 120)} style={{ height: '120px' }} />}
            </Typography>

            <Typography paragraph>
              <ReactMarkdown>{conf.featured_job_description}</ReactMarkdown>
            </Typography>
          </Grid>
        </Grid>
      </Container>
    )
  )
